export const authenticationApis = {
    login: 'agentAuth/login',
    logout: 'agentAuth/logout',
    forgotPassword: 'agentAuth/forgotPassword',
    resetPassword: 'agentAuth/resetPassword',
    decodeForgotPasswordToken: 'agentAuth/decode',
    getScanner: 'v1/api/auth/2fa/scanner',
    getVerification: 'v1/api/auth/2fa/verify',
    checkPassword: 'v1/api/agentAuth/checkPassword',
    changeRefreshToken: 'auth/refresh-tokens',
    contactUsURL: '/contactUs',
    oldPortalApi: 'auth/loginWithOldPortal',
    autoLoginAgent: 'agentAuth/loginWithPortal',
    autoLoginAgentForAdmin: 'agentAuth/loginWithAdmin',
    checkShowTechnicalSupportButtonOrNot:'tenant?skip=0&limit=10&id=3',
    getAccessToken: 'agentAuth/refreshWebToken',
};
